/**
 * Admin Auth Smoke Checks
 * 
 * Automated checks that log warnings if auth/capability state is inconsistent.
 * These run automatically and log to console.
 */

/**
 * Check if super admin has empty capabilities
 * @param {object} me - User object from CapabilityProvider
 */
export function checkSuperAdminCapabilities(me) {
  if (me?.isSuperAdmin && (!me?.capabilities || me.capabilities.length === 0)) {
    console.warn('[RBAC SMOKE CHECK] ⚠️ Super admin has empty capabilities!', {
      actorId: me.actorId || me.id,
      isSuperAdmin: me.isSuperAdmin,
      capabilityCount: me.capabilities?.length || 0,
      buildStamp: me.buildStamp,
      timestamp: new Date().toISOString(),
    });
    return false;
  }
  return true;
}

/**
 * Check if user has a capability but RequireCapability still blocks
 * This is a runtime check that can be called from components
 * @param {string} capability - Capability to check
 * @param {function} has - has() function from useCapabilities
 * @param {boolean} isBlocked - Whether RequireCapability is blocking
 * @param {object} me - User object from CapabilityProvider
 */
export function checkCapabilityMismatch(capability, has, isBlocked, me) {
  if (has(capability) && isBlocked) {
    console.warn('[RBAC SMOKE CHECK] ⚠️ User has capability but RequireCapability is blocking!', {
      capability,
      actorId: me?.actorId || me?.id,
      hasCapability: has(capability),
      isBlocked,
      capabilities: me?.capabilities || [],
      timestamp: new Date().toISOString(),
    });
    return false;
  }
  return true;
}

/**
 * Run all smoke checks
 * @param {object} context - Capability context from useCapabilities
 */
export function runAllSmokeChecks(context) {
  const { me, has } = context;
  
  if (!me) {
    return; // Not loaded yet
  }
  
  // Check 1: Super admin with empty capabilities
  checkSuperAdminCapabilities(me);
  
  // Note: checkCapabilityMismatch is called from RequireCapability component
  // as it needs component-specific context
}

